export default "/assets/images/mila-room-showcase-sm-03.fac84dea673ea0be.webp";